/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AmenityCategory } from './AmenityCategory';
import {
    AmenityCategoryFromJSON,
    AmenityCategoryFromJSONTyped,
    AmenityCategoryToJSON,
} from './AmenityCategory';

/**
 * Filters for a search request
 * @export
 * @interface SearchFilters
 */
export interface SearchFilters {
    /**
     * A list of ratings to filter by
     * @type {Array<number>}
     * @memberof SearchFilters
     */
    ratings?: Array<number>;
    /**
     * If true, only show hotels that the user can afford with points
     * @type {boolean}
     * @memberof SearchFilters
     */
    requireCanAffordPoints?: boolean;
    /**
     * If true, only show hotels that the user can afford with cash
     * @type {boolean}
     * @memberof SearchFilters
     */
    requireCanAffordCash?: boolean;
    /**
     * The minimum percentile of the points deal
     * @type {number}
     * @memberof SearchFilters
     */
    minPointsPercentile?: number;
    /**
     * The maximum percentile of the points deal
     * @type {number}
     * @memberof SearchFilters
     */
    maxPointsPercentile?: number;
    /**
     * The minimum percentile of the cash deal
     * @type {number}
     * @memberof SearchFilters
     */
    minCashPercentile?: number;
    /**
     * The maximum percentile of the cash deal
     * @type {number}
     * @memberof SearchFilters
     */
    maxCashPercentile?: number;
    /**
     * If true, only show hotels from brands that are recommended
     * @type {boolean}
     * @memberof SearchFilters
     */
    onlyRecommendedBrands?: boolean;
    /**
     * If true, include airport hotels in the search results
     * @type {boolean}
     * @memberof SearchFilters
     */
    includeAirportHotels?: boolean;
    /**
     * The minimum total points that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    minTotalPoints?: number;
    /**
     * The maximum total points that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    maxTotalPoints?: number;
    /**
     * The minimum total cash that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    minTotalCash?: number;
    /**
     * The maximum total cash that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    maxTotalCash?: number;
    /**
     * The minimum nightly points that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    minNightlyPoints?: number;
    /**
     * The maximum nightly points that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    maxNightlyPoints?: number;
    /**
     * The minimum nightly cash that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    minNightlyCash?: number;
    /**
     * The maximum nightly cash that the user is willing to spend
     * @type {number}
     * @memberof SearchFilters
     */
    maxNightlyCash?: number;
    /**
     * 
     * @type {Array<AmenityCategory>}
     * @memberof SearchFilters
     */
    amenityCategories?: Array<AmenityCategory>;
    /**
     * The number of rates to return
     * @type {number}
     * @memberof SearchFilters
     */
    numRates?: number;
    /**
     * The field to sort by
     * @type {string}
     * @memberof SearchFilters
     */
    sortBy?: SearchFiltersSortByEnum;
    /**
     * The desirability index to filter by
     * @type {number}
     * @memberof SearchFilters
     */
    desirabilityIndex?: number;
}


/**
 * @export
 */
export const SearchFiltersSortByEnum = {
    RedemptionRatePercentile: 'redemption_rate_percentile',
    CashPercentile: 'cash_percentile'
} as const;
export type SearchFiltersSortByEnum = typeof SearchFiltersSortByEnum[keyof typeof SearchFiltersSortByEnum];


/**
 * Check if a given object implements the SearchFilters interface.
 */
export function instanceOfSearchFilters(value: object): value is SearchFilters {
    return true;
}

export function SearchFiltersFromJSON(json: any): SearchFilters {
    return SearchFiltersFromJSONTyped(json, false);
}

export function SearchFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchFilters {
    if (json == null) {
        return json;
    }
    return {
        
        'ratings': json['ratings'] == null ? undefined : json['ratings'],
        'requireCanAffordPoints': json['require_can_afford_points'] == null ? undefined : json['require_can_afford_points'],
        'requireCanAffordCash': json['require_can_afford_cash'] == null ? undefined : json['require_can_afford_cash'],
        'minPointsPercentile': json['min_points_percentile'] == null ? undefined : json['min_points_percentile'],
        'maxPointsPercentile': json['max_points_percentile'] == null ? undefined : json['max_points_percentile'],
        'minCashPercentile': json['min_cash_percentile'] == null ? undefined : json['min_cash_percentile'],
        'maxCashPercentile': json['max_cash_percentile'] == null ? undefined : json['max_cash_percentile'],
        'onlyRecommendedBrands': json['only_recommended_brands'] == null ? undefined : json['only_recommended_brands'],
        'includeAirportHotels': json['include_airport_hotels'] == null ? undefined : json['include_airport_hotels'],
        'minTotalPoints': json['min_total_points'] == null ? undefined : json['min_total_points'],
        'maxTotalPoints': json['max_total_points'] == null ? undefined : json['max_total_points'],
        'minTotalCash': json['min_total_cash'] == null ? undefined : json['min_total_cash'],
        'maxTotalCash': json['max_total_cash'] == null ? undefined : json['max_total_cash'],
        'minNightlyPoints': json['min_nightly_points'] == null ? undefined : json['min_nightly_points'],
        'maxNightlyPoints': json['max_nightly_points'] == null ? undefined : json['max_nightly_points'],
        'minNightlyCash': json['min_nightly_cash'] == null ? undefined : json['min_nightly_cash'],
        'maxNightlyCash': json['max_nightly_cash'] == null ? undefined : json['max_nightly_cash'],
        'amenityCategories': json['amenity_categories'] == null ? undefined : ((json['amenity_categories'] as Array<any>).map(AmenityCategoryFromJSON)),
        'numRates': json['num_rates'] == null ? undefined : json['num_rates'],
        'sortBy': json['sort_by'] == null ? undefined : json['sort_by'],
        'desirabilityIndex': json['desirability_index'] == null ? undefined : json['desirability_index'],
    };
}

export function SearchFiltersToJSON(value?: SearchFilters | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ratings': value['ratings'],
        'require_can_afford_points': value['requireCanAffordPoints'],
        'require_can_afford_cash': value['requireCanAffordCash'],
        'min_points_percentile': value['minPointsPercentile'],
        'max_points_percentile': value['maxPointsPercentile'],
        'min_cash_percentile': value['minCashPercentile'],
        'max_cash_percentile': value['maxCashPercentile'],
        'only_recommended_brands': value['onlyRecommendedBrands'],
        'include_airport_hotels': value['includeAirportHotels'],
        'min_total_points': value['minTotalPoints'],
        'max_total_points': value['maxTotalPoints'],
        'min_total_cash': value['minTotalCash'],
        'max_total_cash': value['maxTotalCash'],
        'min_nightly_points': value['minNightlyPoints'],
        'max_nightly_points': value['maxNightlyPoints'],
        'min_nightly_cash': value['minNightlyCash'],
        'max_nightly_cash': value['maxNightlyCash'],
        'amenity_categories': value['amenityCategories'] == null ? undefined : ((value['amenityCategories'] as Array<any>).map(AmenityCategoryToJSON)),
        'num_rates': value['numRates'],
        'sort_by': value['sortBy'],
        'desirability_index': value['desirabilityIndex'],
    };
}

